import React from "react";
import { Link } from "react-router-dom";
import { Path } from "../../constants/enum/path.emum";
import "./404.css";

const Error404 = () => {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404" />
        <h1>404</h1>
        <h2>กำลังปรับปรุงหน้าเว็บเพจ</h2>
        <p>แจ้งเตือน!! หน้าเว็บ กำลังถูกปรับปรุงอยู่ขณะนี้</p>
        <Link to={Path.HOME}>กลับไปยังหน้าแรก</Link>
      </div>
    </div>
  );
};

export default Error404;
